import { isStringNotEmpty } from "./objectUtils";

const MAX_DEPTH = 2;
const PREFERRED_OBJECT_KEYS = [
    "email",
    "address",
    "name",
    "label",
    "title",
    "subject",
    "from",
    "to",
    "replyTo",
    "mailboxAddress",
    "deliveredTo",
    "value",
    "id"
];

const toPrimitiveText = (value) => {
    if (typeof value === "string") {
        return value;
    }

    if (typeof value === "number" || typeof value === "bigint") {
        return String(value);
    }

    if (typeof value === "boolean") {
        return value ? "true" : "false";
    }

    if (value instanceof Date) {
        return value.toISOString();
    }

    return "";
};

export const toDisplayText = (value, fallback = "", depth = 0) => {
    const primitiveText = toPrimitiveText(value);
    if (isStringNotEmpty(primitiveText)) {
        return primitiveText;
    }

    if (Array.isArray(value)) {
        const joinedText = value
            .map((item) => toDisplayText(item, "", depth + 1))
            .filter((item) => isStringNotEmpty(item))
            .join(", ");

        return isStringNotEmpty(joinedText) ? joinedText : fallback;
    }

    if (value && typeof value === "object" && depth < MAX_DEPTH) {
        const name = toDisplayText(value.name, "", depth + 1);
        const email = toDisplayText(value.email, "", depth + 1);
        const address = toDisplayText(value.address, "", depth + 1);

        if (isStringNotEmpty(name) && isStringNotEmpty(email)) {
            return `${name} <${email}>`;
        }

        if (isStringNotEmpty(name) && isStringNotEmpty(address)) {
            return `${name} <${address}>`;
        }

        for (const key of PREFERRED_OBJECT_KEYS) {
            const nextValue = toDisplayText(value[key], "", depth + 1);
            if (isStringNotEmpty(nextValue)) {
                return nextValue;
            }
        }
    }

    return fallback;
};
